// var styleguide = require('./modules/style-guide.js');
var stickyNav = require('./modules/stickyNav.js');
var accordions = require('./modules/accordions.js');
var cards = require('./modules/cards.js');
var menu = require('./modules/menu.js');
var sliders = require('./modules/sliders.js');
var svg = require('./modules/svg.js');
var gallery = require('./modules/gallery');
var underliner = require('./modules/underliner');
var singleHeader = require('./modules/singleHeader');
var searchBreadcrumbs = require('./modules/searchBreadcrumbs');
var searchRemoveFacets = require('./modules/searchRemoveFacets');
//var menuItemTabIndex = require('./modules/menuItemTabIndex');
var mainMenuTabbing = require('./modules/mainMenuTabber');
var facetDate = require('./modules/facetDate');
// var fadeIn = require('./modules/fadeIn');
var facetScroll = require('./modules/facetScroll');
var triggerTaxExemptUpdate = require('./modules/triggerTaxExemptUpdate');

// Make sure that you init the styleguide first.
// styleguide.init();
stickyNav.init();
underliner.init();
singleHeader.init();
accordions.init();
cards.init();
menu.init();
sliders.init();
svg.init();
gallery.init();
//menuItemTabIndex.init();
mainMenuTabbing.init();
// fadeIn.init();
triggerTaxExemptUpdate.init();

if (typeof FWP !== 'undefined') {
	searchBreadcrumbs.init();
	searchRemoveFacets.init();
	facetDate.init();
	facetScroll.init();
}
